var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h5"},[_c('van-nav-bar',{attrs:{"left-text":"返回","left-arrow":"","title":_vm.title},on:{"click-left":_vm.back}}),_c('div',{staticClass:"h5-page"},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }